// removed by extract-text-webpack-plugin
module.exports = {"widget-maker":"_30gi5Xrdn _2l0xl0HVf","paragraph":"_1hD-VawcZ _1C-lRJLgc xBrMYP3IH","input":"_1LCA6ITtf _3C8l8JJzR _3cWZ9MSKx _3Wgp0B0Gt _1C3le7ltj _3n87MdY-3 Ve18E2zgo APZH6AEYZ OIsiVUT2J _2X0mllu17 bHDRqtlU2 rgQ1hO_KM _3hAOedd31 _2zVYNxcNW _1t9KApSC5 _3O39zhbBl n134zV1_r _2ltOFCwED _1OqJ1vEYi yJ3aJSEV8 aokgWzHRc","label":"u8ukvfclP _3fIeCGwgt _2r1vMEdE0 rOZT_820O"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/widget-maker/widget-maker.css
 ** module id = 684
 ** module chunks = 0
 **/